"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLoadingState = exports.getShowDistance = exports.getResultSize = exports.getResultIndex = exports.getSearchAgentAuthenticationState = exports.getAnchorNavigationHideItemOnDetailPage = exports.getResultsCountState = exports.getResultsViewType = exports.getOutdatedCount = exports.getUiStateRaw = void 0;
const getUiStateRaw = (state) => state.ui || {};
exports.getUiStateRaw = getUiStateRaw;
const getOutdatedCount = (state) => (0, exports.getUiStateRaw)(state).outdatedCount || 0;
exports.getOutdatedCount = getOutdatedCount;
const getResultsViewType = (state) => (0, exports.getUiStateRaw)(state).resultsViewType || '';
exports.getResultsViewType = getResultsViewType;
const getResultsCountState = (state) => (0, exports.getUiStateRaw)(state).resultsCount || {};
exports.getResultsCountState = getResultsCountState;
const getAnchorNavigationHideItemOnDetailPage = (state) => (0, exports.getUiStateRaw)(state).anchorNavigationHideItemOnDetailPage || {};
exports.getAnchorNavigationHideItemOnDetailPage = getAnchorNavigationHideItemOnDetailPage;
const getSearchAgentAuthenticationState = (state) => (0, exports.getUiStateRaw)(state).searchAgentAuthentication || false;
exports.getSearchAgentAuthenticationState = getSearchAgentAuthenticationState;
const getResultIndex = (state) => (0, exports.getResultsCountState)(state).from || 0;
exports.getResultIndex = getResultIndex;
const getResultSize = (state) => (0, exports.getResultsCountState)(state).size || 0;
exports.getResultSize = getResultSize;
const getShowDistance = (state) => (0, exports.getUiStateRaw)(state).showDistance || false;
exports.getShowDistance = getShowDistance;
const getLoadingState = (state) => (0, exports.getUiStateRaw)(state).loading || false;
exports.getLoadingState = getLoadingState;
//# sourceMappingURL=ui.js.map